import React from "react"
import {Row, Col} from 'antd';
import "./course-details.scss"
import WeekCard from "./week-card"

export default props =>
    <Row type="flex" justify="center" gutter={24} className={"course-detail"}>
        <Col xs={24} md={8}>
            <div className="detail-month">
                <div className="month-top" data-sal="slide-up"
                     data-sal-duration="1000"
                     data-sal-easing="ease">
                    <div className="top-line"/>
                    <div className="title">第一阶段</div>
                </div>
                <WeekCard title="Week1" color="#1FAE8D">
                    工作流 + Sketch进阶+ 视觉规范
                </WeekCard>
                <WeekCard title="Week2" color="#FF9965">
                    产品思维 + 交互设计 + 原型交互文档
                </WeekCard>
                <WeekCard title="Week3" color="#C93D84">
                    iOS规范 + 界面视觉设计
                </WeekCard>
                <WeekCard title="Week4" color="#3D89F8">
                    图标/矢量绘图 + 规范文档 + 切图产出及适配
                </WeekCard>
                <div className="software">
                    <img src="https://img.uigreat.com/pxfer/sketch.png" alt=""/>
                    <img src="https://img.uigreat.com/pxfer/ai.png" alt=""/>
                    <img src="https://img.uigreat.com/szpxfer/mindnote.png" alt=""/>
                    <img src="https://img.uigreat.com/pxfer/lanhu.png" alt=""/>
                </div>
            </div>
        </Col>
        <Col xs={24} md={8}>
            <div className="detail-month">
                <div className="month-top" data-sal="slide-up"
                     data-sal-duration="1000"
                     data-sal-easing="ease">
                    <div className="top-line blue"/>
                    <div className="title blue">第二阶段</div>
                </div>
                <WeekCard title="Week1" color="#1FAE8D">
                    设计方法论：大厂真实项目需求实践，矢量形象IP绘制海报的设计方法
                </WeekCard>
                <WeekCard title="Week2" color="#FF9965">
                    字体设计速通法：一周掌握字体设计方法，造字设计 + 运营字体设计 + 字系统设计
                </WeekCard>
                <WeekCard title="Week3" color="#C93D84">
                    插画系统组件库设计：如何针对互联网大厂，高效建立一套插画系统库
                </WeekCard>
                <WeekCard title="Week4" color="#3D89F8">
                    插画系统的规范建立：针对插画系统，利用“言之有物性”，建立一整套成熟的规范系统
                </WeekCard>
                <div className="software">
                    <img src="https://img.uigreat.com/pxfer/ai.png" alt=""/>
                    <img src="https://cdn.uigreat.com/faa1af82-6568-440b-bcdd-21225770df5d.png" alt=""/>
                    <img src="https://img.uigreat.com/szpxfer/draw1.png" alt=""/>
                </div>
            </div>
        </Col>
        <Col xs={24} md={8}>
            <div className="detail-month">
                <div className="month-top" data-sal="slide-up"
                     data-sal-duration="1000"
                     data-sal-easing="ease">
                    <div className="top-line red"/>
                    <div className="title red">第三阶段</div>
                </div>
                <WeekCard title="Week1" color="#1FAE8D">
                    Principle高保真制作 + AE动效包装 + 网页设计
                </WeekCard>
                <WeekCard title="Week2" color="#FF9965">
                    品牌升级 + GUI规范文档 + keynote使用技巧
                </WeekCard>
                <WeekCard title="Week3" color="#C93D84">
                    产品思维 + 行业黑话 + 个人向作品集包装思路拆解
                </WeekCard>
                <WeekCard title="Week4" color="#3D89F8">
                    面试技巧 + 作品集包装 + 壁纸君竞进
                </WeekCard>
                <div className="software">
                    <img src="https://img.uigreat.com/pxfer/ae.png" alt=""/>
                    <img src="https://img.uigreat.com/szpxfer/principle1.png" style={{height:"37px"}} alt=""/>
                    <img src="https://img.uigreat.com/szpxfer/keynote.png" alt=""/>
                </div>
            </div>
        </Col>
    </Row>
